export const DEFAULT_BASE_URL = `https://${window.location.host}`;
export const GET_NAV_OPTIONS_URL = '/navUtils/getNavOptions';
export const LOGOUT_URL = '/logout';

// Common
export const GET_COUNTRIES_URL = '/common/getCountries';
export const GET_STATES_URL = '/common/getStates';
export const GET_TIMEZONE_MAP_URL = '/common/getTimezoneMap';

// Insights
export const CREATE_PHOTO_GALLERY_REPORT_URL = '/insights/createPhotoGalleryReport';
export const DELETE_PHOTO_GALLERY_REPORT_URL = '/insights/deletePhotoGalleryReport';
export const EDIT_PHOTO_GALLERY_REPORT_URL = '/insights/editPhotoGalleryReport';
export const GET_PHOTO_GALLERIES_URL = '/insights/getGalleries';
export const REFRESH_GALLERY_DATA_URL = '/insights/refreshGalleryData';
export const REMOVE_GALLERY_PHOTOS_URL = '/insights/removeGalleryPhotos';
export const UPDATE_GALLERY_PHOTO_COUNT_URL = '/insights/updateGalleryPhotoCount';
export const GET_GALLERY_DATA_URL = '/insights/getPhotoGalleryData';
export const EXPORT_HTML_TO_PDF_URL = '/insights/exportHtmlToPdf';

export const CHECK_LOOKER_REPORT_STATUSES_URL = '/looker/checkLookerReportStatuses';
export const GET_LOOKER_DOMAIN_URL = '/looker/getLookerProdOrDev';
export const GET_LOOKER_EMBED_RESOURCE_LINK_URL = '/looker/getEmbedLinkForResource';
export const GET_LOOKER_REPORT_LIST_ITEMS_URL = '/looker/getReportDefinitions';
export const RUN_LOOKER_REPORT_URL = '/looker/runLookerReport';
export const GET_INSIGHTS_PREFERENCES_URL = '/looker/getInsightsPreferences';

export const ROTATE_GALLERY_PHOTO_BASE_URL = '/imageprocessor/rotate';

export const GET_REPORT_FORM_URL = '/customreport/getReportForm';
export const GET_REPORT_OPTION_URL = '/customreport/getReportOption';

// Locations Hub
export const GET_CUSTOM_FIELD_LABELS = '/locationshub/getCustomFieldLabels';
export const GET_LOCATIONS = '/locationshub/getLocations';
export const GET_LOCATIONS_FILTER_OPTIONS = '/locationshub/getLocationsFilterOptions';
export const GET_LOCATION_QUALIFIED_REPS_DETAILS = '/locationshub/getQualifiedRepsForLocation';
export const GET_LOCATION_LISTS_DETAILS = '/locationshub/getListsForLocation';
export const REMOVE_LOCATION_FROM_LIST = '/locationshub/removeLocationFromList';
export const UPDATE_LOCATION = '/api/location';
export const UPDATE_PEOPLE_GEOCODE = '/locationshub/updatePeopleGeocode';
export const CLEAR_LOCATION_CACHE = '/locationshub/deleteGetStoresInfoCache';
export const GET_MAPBOX_TOKEN = '/locationshub/getMapboxToken';
export const GET_MPLAN_RESPONSE_SHARE_URL = '/locationshub/getMplanResponseShareUrl';
export const GET_MPLAN_UNSUBMITTED_FOR_LOCATION = 'locationshub/getUnsubmittedMplansForLocation';
export const GET_MPLAN_SUBMITTED_FOR_LOCATION = 'locationshub/getSubmittedMplansForLocation';
export const GET_CUSTOM_FIELDS_LIST = '/customfields/getCustomFields';
export const DELETE_LOCATION_CUSTOM_FIELD = '/customfields/deleteCustomField';
export const GET_LISTS = '/lists/getLists';
export const DELETE_LIST = '/lists/deleteList';
export const CREATE_LIST = '/lists/createList';
export const GET_LIST_LOCATIONS = '/lists/getListLocations';
export const BULK_DELETE_LISTS = '/lists/bulkDeleteLists';
export const EDIT_LIST_NAME = '/lists/editListName';
export const UPDATE_LIST_ARCHIVE_STATUS = '/lists/editArchiveStatus';

// Yapp
export const DELETE_DRAFT_ANNOUNCEMENT_URL = '/yapp/deleteAnnouncementDraft';
export const GET_USER_DRAFT_ANNOUNCEMENTS = '/yapp/getAnnouncementDrafts/';
export const FIND_CONTACTS_URL = '/yapp/findUser';
export const FIND_ROLES = '/yapp/findRole';
export const GET_ATTACHMENT_URL = '/yapp/getAttachmentURLs';
export const GET_THREAD_URL = '/yapp/getThread';
export const GET_USER_THREADS = '/yapp/getAllUserThreads/';
export const GET_USERS_BY_IDS = '/yapp/getUsersByIDs';
export const GET_USERS_ONLINE_STATUS = '/yapp/getUsersOnlineStatus';
export const NEW_ANNOUNCEMENT_URL = '/yapp/newAnnouncement';
export const NEW_MESSAGE_URL = '/yapp/newMessageThread';
export const SEND_MESSAGE_URL = '/yapp/sendMessage';
export const UPLOAD_ATTACHMENTS = '/yapp/uploadAttachments';
export const UPSERT_DRAFT_ANNOUNCEMENT_URL = '/yapp/upsertAnnouncementDraft';

export const GET_USER_INFO = '/users/getUserInfo';
export const GET_USERS_URL = '/users/getUsers';
export const GET_USER_LOCALE_URL = '/users/getUserLocale';
export const GET_ANNOUNCEMENT_STATS_URL = '/yapp/getAnnouncementStats';
export const IMPORT_BATCH_LOCATIONS = '/api/batch/location/';
export const IMPORT_PREFERRED_REPS_URL = '/storesextcontroller/SchedulingPreferredRepTemplate/';
export const IMPORT_PRIMARY_REP_LOCATION_URL = '/storesextcontroller/importRepPrimaryLocations/';
export const GET_RETAILERS_API = '/api/retailer';
export const GET_LOCATIONS_API = '/api/location';
export const BATCH_EDIT_LOCATIONS_URL = '/api/batch/location/';
export const GET_FILE_API = '/api/file/';

// UI User Cache
export const SET_MESSAGING_CACHE_URL = '/UIUserCache/setCacheValue/messaging';
export const GET_MESSAGING_CACHE_URL = '/UIUserCache/getCacheValue/messaging';
export const SET_CONTACTS_CACHE_URL = '/UIUserCache/setCacheValue/contacts';
export const GET_CONTACTS_CACHE_URL = '/UIUserCache/getCacheValue/contacts';
export const SET_LAST_ACTIVE_CACHE_URL = '/UIUserCache/setCacheValue/lastActive';
export const GET_LAST_ACTIVE_CACHE_URL = '/UIUserCache/getCacheValue/lastActive';
export const SET_ANNOUNCEMENT_CACHE_URL = '/UIUserCache/setCacheValue/announcement';
export const GET_ANNOUNCEMENT_CACHE_URL = '/UIUserCache/getCacheValue/announcement';

// Work Hub
export const GET_WORK_GRID_URL = '/workhub/getmPlans';
export const GET_WORK_TEMPLATE_URL = '/workhub/getTemplates';
export const GET_WORK_DRAFT_URL = '/workhub/getDrafts';
export const GET_VISIT_DETAILS_URL = '/workhub/visitDetails';
export const GET_VISIT_DETAILS_EXPORT_URL = '/workhub/visitDetailsExport';
export const GET_WORK_PRINT_URL = '/rpe/printmplan/';
export const GET_PRINT_RESPONSES_URL = '/workhub/printResponsesByWorkLog/';
export const GET_EMAIL_RESPONSES_URL = '/workhub/emailResponsesByWorkLog';
export const GET_CREATE_SHARE_LINK_URL = '/workhub/createShareLink';
export const GET_LEGACY_CUMULATIVE_RESPONSES = '/mplansextcontroller/getQuestionResponsesForMplan/';
export const EXPORT_MPLAN_CUMULATIVE_RESPONSES_PDF = 'mplansextcontroller/getQuestionResponsesForMplan/?pdf=1&mPlanID=';
export const GET_THRESHOLD_SETTINGS_URL = '/workhub/getWorkThresholdSettings';
export const SAVE_THRESHOLD_SETTINGS_URL = '/workhub/updateWorkThresholdSettings';
export const GET_CUSTOM_ATTRIBUTES_URL = '/workhub/getCustomAttributeLabels';
export const GET_WORK_EXPORT_URL = '/workhub/exportWork';
export const GET_RECURRENCE_DETAIL_URL = '/workhub/getRecurrenceDetails';
export const GET_CR_EXPORT_URL = '/workhub/exportCumulativeResponses';
export const GET_BULK_CR_EXPORT_URL = '/workhub/exportBulkCumulativeResponses';
export const GET_BULK_ITEM_REQUEST_EXPORT_URL = '/workhub/exportBulkItemCountRequests';
export const GET_BULK_MPLAN_PHOTOS_EXPORT_URL = '/workhub/exportMPlanPhotos';
export const START_WORK_EXPORT_JOB_URL = '/workhub/startExportJob';
export const GET_RECENT_WORK_EXPORT_JOBS_URL = '/workhub/getRecentExportJobs';
export const DISMISS_WORK_EXPORT_JOB_URL = '/workhub/dismissExportJob';
export const GET_WORK_EXPORT_JOB_STATUS_URL = '/workhub/getExportJobStatus';
export const GET_WORK_EXPORT_JOB_DOWNLOAD_URL = '/workhub/getExportJobDownload';
export const GET_CR_ITEM_EXPORT_URL = '/workhub/exportItemCountRequests';
export const GET_ITEM_REQUESTS_URL = '/workhub/getItemRequests';
export const GET_CREATE_WORK_URL = '/workhub/getmPlan';
export const GET_SALES_TOOL_URL = '/workhub/getSalesToolsForProject';
export const GET_SALES_TOOL_FILES_URL = '/workhub/getSalesToolFilesForProject';
export const GET_MPLAN_SALES_TOOL_URL = '/workhub/getmPlanSalesTools';
export const GET_MPLAN_MEDIA_FILES_URL = '/workhub/getmPlanMediaFiles';
export const GET_PROJECT_MEDIA_FILES_URL = '/workhub/getProjectMediaFiles';
export const UPLOAD_MEDIA_FILE_URL = '/workhub/uploadMediaFile';
export const SAVE_MEDIA_LINKS_URL = '/workhub/createMediaLinks';
export const DUPLICATE_MPLAN_URL = '/workhub/duplicateProject';
export const GET_WORK_ESCALATION_CONFIGURATION_URL = '/workhub/getWorkEscalationConfiguration';
export const WORK_ESCALATION_POINT_API_URL = '/api/escalationPoint';
export const GET_SHELF_CHECK_TOOLS_URL = '/workhub/getShelfCheckTools';

export const GET_LOCATION_CONTACTS = '/locationcontact/getLocationContacts';
export const GET_LOCATION_NOTES = 'locationnote/getLocationNote';

export const UPDATE_CUSTOM_FIELD = '/entities/update_customfield';

export const GET_WORK_EDIT_URL = '/projects/build/';
export const GET_WORK_PREVIEW_URL = '/mplan/preview/';
export const GET_MPLAN_API_URL = 'api/mplan/';
export const CREATE_NEW_MPLAN = '/mplan/createnew/';
export const GET_MPLANID_URL = '/workhub/getmPlanIDFromMVID';
export const GET_SURVEY_COUNT_URL = '/workhub/getSurveyCount';
export const GET_SURVEY_DATA_URL = '/surveyBuilder/getSurveyData/';
export const SAVE_SURVEY_DATA_URL = '/surveyBuilder/saveSurveyData/';
export const GET_TEMPLATE_TYPE_URL = '/workhub/getTemplateTypes';

// Opportunities
export const GET_QUALIFIED_REPS_FOR_SCHEDULING_URL = '/opportunities/getQualifiedRepsForScheduling';
export const GET_SCHEDULED_VISITS_URL = '/opportunities/getScheduledVisits';
export const GET_OPPORTUNITIES_FOR_VISIT_URL = '/opportunities/getOpportunitiesForVisit';
export const GET_PREVIOUS_OPPORTUNITIES_FOR_MPLAN_URL = '/opportunities/getPreviousOpportunitiesForMplan';
export const UPDATE_OPPORTUNITIES_DECLINE_URL = '/opportunities/updateOpportunitiesDecline';
export const ACCEPT_OPPORTUNITY_URL = '/opportunities/acceptOpportunity';
export const GET_POTENTIAL_OPPORTUNITIES_URL = '/opportunities/getPotentialOpportunities';
export const CREATE_OPPORTUNITIES_URL = '/opportunities/createOpportunities';
export const GET_OPPORTUNITIES_EXPORT_DATA_URL = '/opportunities/getOpportunitiesExport';

// Add/Edit Project
export const CREATE_PROJECT = '/api/mplan';
export const CREATE_ASSIGNMENT = '/api/assignment';

// Rep
export const REP_SCHEDULE_URL_LEGACY = '/rep/schedule/';

// Rep Profile
export const GET_PAYROLL_EXPENSES = '/repprofile/getPayrollExpenses/';
export const SAVE_PAYROLL_EXPENSES = '/repprofile/savePayrollExpenses';
export const GET_REP_INFORMATION = '/repprofile/getRepInformation/';
export const GET_PRIMARY_LOCATIONS = '/repprofile/getPrimaryLocations';
export const SAVE_PERSONAL_INFORMATION = '/repprofile/savePersonalInformation';
export const SAVE_SHIPPING_PRIMARY_LOCATION = 'repprofile/saveShippingPrimaryLocation/';
export const SAVE_GENERAL_INFORMATION = '/repprofile/saveGeneralInformation';
export const GET_NOTES = '/repprofile/getNotes?page=1&start=0&limit=25&sort=%5B%7B%22property%22%3A%22lastedited%22%2C%22direction%22%3A%22DESC%22%7D%5D';
export const SAVE_NOTE = 'repprofile/createNote';
export const UPDATE_NOTE = 'repprofile/updateNote';
export const REMOVE_NOTE = 'repprofile/deleteNote';
export const GET_PEOPLE_HUB_PREFS = 'repprofile/getPeopleHubPrefs';
export const UPLOAD_REP_PHOTO = 'repprofile/uploadRepPhoto';
export const UPDATE_REP_PHOTO = 'repprofile/updateRepPhoto';
export const GET_REP_SUPERVISORS = 'repprofile/getRepSupervisors/';
export const GET_REP_ATTRIBUTES = '/repprofile/getRepAttributes';
export const GET_REP_ATTRIBUTE_EDITOR = '/repprofile/getRepAttributeEditor';
export const SAVE_REP_ATTRIBUTES = '/repprofile/saveRepAttributes';

// Rep Hub
export const GET_REP_LISTS_DETAILS = '/rephub/getRepList';
export const SEND_REP_INVITE_EMAIL_URL = '/rephub/inviteRepEmail';
export const SEND_REP_INVITE_CSV_URL = '/rephub/inviteRepCSV';
export const FETCH_REP_ASSIGNMENTS = '/rephub/getAssignments';
export const IMPORT_REP_ATTRIBUTE_DATA_URL = '/rephub/importRepAttributeData';
export const IMPORT_ADD_BULK_REP_DATA_URL = '/rephub/importAddBulkRepData';
export const IMPORT_EDIT_BULK_REP_DATA_URL = '/rephub/importEditBulkRepData';
export const IMPORT_DEACTIVATE_BULK_REP_DATA_URL = '/rephub/importDeactivateBulkRepData';
export const IMPORT_REP_ROLES_DATA_URL = '/rephub/importRepRolesData';
export const IMPORT_REP_LOCATIONS_DATA_URL = '/rephub/importRepLocationsData';
export const DOWNLOAD_ADD_REP_CSV = '/download/AddRepsTemplate';
export const DOWNLOAD_EDIT_REP_CSV = '/download/EditRepsTemplate';
export const DOWNLOAD_DEACTIVATE_REP_CSV = '/download/DeactivateRepsTemplate';
export const DOWNLOAD_MANAGE_ROLES_CSV = '/download/ManageBulkRepRolesTemplate';
export const DOWNLOAD_MANAGE_LOCATIONS_CSV = '/download/ManageBulkRepLocationsTemplate';
export const GET_INVITED_REPS = '/rephub/getInvitedReps';
export const DELETE_REP_INVITATION = '/rephub/deleteInvitation';
export const RESEND_REP_INVITATION = '/rephub/resendInvitation';
export const GET_INACTIVE_REPS = '/rephub/getInactiveReps';
export const REACTIVATE_REP_URL = '/rephub/reactivateRep';

// Items Hub
export const GET_ITEM_GRID_COLUMN_URL = '/items/getItemAttributes';
export const GET_ITEM_GRID_DATA_URL = '/items/getItems';
export const GET_ITEMS_HUB_SIDE_NAV = '/items/getNavOptions';
export const GET_ITEMS_PREFS = '/items/getItemManagerPrefs';
export const GET_ITEM_IMAGES = '/items/getItemImages';
export const GET_ITEM_ACTIONS = '/items/getActionInstances';
export const GET_ITEM_ACTION_COLUMN = '/items/getActionAttributes';
export const GET_ITEM_ACTION_ORDER_DATA_URL = '/items/getActionInstanceItems';
export const DOWNLOAD_ITEMS_CSV = 'download/AddItemsTemplate';
export const DOWNLOAD_GLOBAL_CSV = 'download/UpdateGlobalItemsTemplate';
export const DOWNLOAD_LOC_ATTR_CSV = 'download/UpdateLocationAttributesTemplate';
export const DOWNLOAD_LOC_AVAIL_CSV = 'download/RepInvitationImportTemplate';
export const IMPORT_ITEMS = '/items/importItems';
export const UPDATE_ITEM_GLOBAL_ATTRIBUTES = '/items/updateItemGlobalAttributes';
export const UPDATE_ITEM_LOCATION_ATTRIBUTES = '/items/updateItemLocationAttributes';
export const UPDATE_ITEM_LOCATION_AVAILABILITY = '/items/updateItemLocationAvailability';
export const EXPORT_ITEM_ACTION_ITEM = '/itemmanager/exportActionInstance';
export const DELETE_ACTION_INSTANCE = '/items/deleteActionInstance';
export const GET_ITEM_SETS = '/items/getItemSets';
export const GET_ITEM_SET_ITEMS = '/items/getItemsByItemSet';
export const TOGGLE_ITEM_SET_ACTIVE = '/items/updateItemSetActive';
export const ITEM_SET_API_ENDPOINT = '/api/itemset';
export const ITEM_SET_BULK_API_ENDPOINT = '/api/batch/itemset';
export const ITEM_SET_DELETE = '/items/deleteItemSet';

// mPlan Reissue Urls
export const GET_MPLAN_LOCATION_REISSUE_CONDITION = '/mplanreissue/getMplanLocationReissueCondition';
export const GET_PENDING_WORK_WINDOW_OPTIONS = '/mplanreissue/getPendingWorkWindowOptions';
export const GET_QUALIFIED_REPS = '/mplanreissue/getQualifiedReps';
export const GET_REP_DATA = '/mplanreissue/getRepsData';
export const CREATE_PENDING_WORK = '/mplanreissue/createPendingWork';
export const END_PENDING_WORK = '/mplanreissue/endPendingWork';
export const GET_VISIT_CAN_REISSUE_CONDITION_URL = '/mplanreissue/getVisitCanReissueCondition';

// Work Approval Urls
export const APPROVE_WORK_URL = '/mplanreissue/approveWork';

// people attributes
export const SAVE_NEW_SECTION_URL = '/peopleattributescontroller/createSection';
export const EDIT_SECTION_URL = '/peopleattributescontroller/editSection';
export const GET_PEOPLE_ATTRIBUTES_URL = '/peopleattributescontroller/getAttributes';
export const DELETE_ATTRIBUTE_URL = '/peopleattributescontroller/deleteAttribute';
export const GET_ATTRIBUTE_DETAILS_URL = '/peopleattributescontroller/getAttributeDetails';
export const EDIT_ATTRIBUTE_URL = '/peopleattributescontroller/editAttribute';
export const CREATE_ATTRIBUTE_URL = '/peopleattributescontroller/createAttributes';
export const DELETE_ATTRIBUTE_SECTION_URL = '/peopleattributescontroller/deleteAttributeSection';
export const EXPORT_ATTRIBUTES_TO_CSV_URL = '/peopleattributescontroller/exportAttributesToCSV';

export const MAPBOX_GEOCODER = 'https://api.mapbox.com/geocoding/v5/mapbox.places/';

// People Availability
export const GET_PEOPLE_AVAILABILITY_STANDARD_HOURS = '/peopleavailability/getRepStandardHours';
export const GET_PEOPLE_AVAILABILITY_STANDARD_HOURS_OVERRIDES = '/peopleavailability/getRepStandardHoursOverrides';
export const UPDATE_PEOPLE_AVAILABILITY_STANDARD_HOURS = '/peopleavailability/updateRepStandardHours';
export const CREATE_RECURRING_AVAILABILITY = '/peopleavailability/createRecurringAvailability';
export const READ_RECURRING_AVAILABILITY = '/peopleavailability/readRecurringAvailability';
export const UPDATE_RECURRING_AVAILABILITY = '/peopleavailability/updateRecurringAvailability';
export const DELETE_RECURRING_AVAILABILITY = '/peopleavailability/deleteRecurringAvailability';

// Scheduling
export const GET_SCHEDULING_TIMEOUT_URL = '/schedulingcontroller/getSchedulingPrefs';
export const GET_SCHEDULED_EVENTS = '/schedulingcontroller/getScheduledEvents';
export const GET_AVAILABLE_REPS = '/schedulingcontroller/getAvailableReps';
export const GET_NON_SCHEDULED_VISITS_URL = '/schedulingcontroller/getNonScheduledVisits';
export const GET_MORE_FILTERS_OPTIONS_URL = '/schedulingcontroller/getMoreFiltersOptions';
export const GET_TIME_MANAGER_FILTERED_REPS_URL = '/schedulingcontroller/getTimeManagerFilteredReps';
export const IMPORT_SCHEDULE_URL = '/schedulingcontroller/importSchedule';
export const GET_OVERLAPPING_SCHEDULE_CHECK_URL = '/schedulingcontroller/overlappingScheduleCheck';
export const GET_FILTERED_SORTED_REPS_URL = '/schedulingcontroller/getFilteredSortedReps';
export const SCHEDULED_EVENT_API_URL = '/api/scheduledevent';
export const BATCH_SCHEDULED_EVENT_API_URL = '/api/batch/scheduledevent';
export const GET_FULL_CALENDAR_LICENSE_KEY_URL = '/schedulingcontroller/getFullCalendarLicenseKey';

export const SET_WORK_CACHE_URL = '/UIUserCache/setCacheValue/work?static=true';
export const GET_WORK_CACHE_URL = '/UIUserCache/getCacheValue/work?static=true';
export const CLEAR_WORK_CACHE_URL = '/UIUserCache/clearCacheByKey/work?static=true';
export const SET_TEMPLATE_CACHE_URL = '/UIUserCache/setCacheValue/template?static=true';
export const GET_TEMPLATE_CACHE_URL = '/UIUserCache/getCacheValue/template?static=true';
export const CLEAR_TEMPLATE_CACHE_URL = '/UIUserCache/clearCacheByKey/template?static=true';
export const SET_DRAFT_CACHE_URL = '/UIUserCache/setCacheValue/draft?static=true';
export const GET_DRAFT_CACHE_URL = '/UIUserCache/getCacheValue/draft?static=true';
export const CLEAR_DRAFT_CACHE_URL = '/UIUserCache/clearCacheByKey/draft?static=true';
export const SET_MPLAN_CACHE_URL = '/UIUserCache/setCacheValue/mplan?static=true';
export const GET_MPLAN_CACHE_URL = '/UIUserCache/getCacheValue/mplan?static=true';
export const CLEAR_MPLAN_CACHE_URL = '/UIUserCache/clearCacheByKey/mplan?static=true';
export const SET_SCORED_CACHE_URL = '/UIUserCache/setCacheValue/scored?static=true';
export const GET_SCORED_CACHE_URL = '/UIUserCache/getCacheValue/scored?static=true';
export const CLEAR_SCORED_CACHE_URL = '/UIUserCache/clearCacheByKey/scored?static=true';
export const SET_ITEM_ACTION_CACHE_URL = '/UIUserCache/setCacheValue/itemAction?static=true';
export const GET_ITEM_ACTION_CACHE_URL = '/UIUserCache/getCacheValue/itemAction?static=true';
export const CLEAR_ITEM_ACTION_CACHE_URL = '/UIUserCache/clearCacheByKey/itemAction?static=true';
export const SET_ITEM_ORDER_CACHE_URL = '/UIUserCache/setCacheValue/itemOrder?static=true';
export const GET_ITEM_ORDER_CACHE_URL = '/UIUserCache/getCacheValue/itemOrder?static=true';
export const CLEAR_ITEM_ORDER_CACHE_URL = '/UIUserCache/clearCacheByKey/itemOrder?static=true';

export const SET_REP_HUB_CACHE_URL = '/UIUserCache/setCacheValue/repHub?static=true';
export const GET_REP_HUB_CACHE_URL = '/UIUserCache/getCacheValue/repHub?static=true';
export const CLEAR_REP_HUB_CACHE_URL = '/UIUserCache/clearCacheByKey/repHub?static=true';

export const SET_CLIENT_MANAGER_GRID_CACHE_URL = '/UIUserCache/setCacheValue/clientManagerGrid?static=true';
export const GET_CLIENT_MANAGER_GRID_CACHE_URL = '/UIUserCache/getCacheValue/clientManagerGrid?static=true';
export const CLEAR_CLIENT_MANAGER_GRID_CACHE_URL = '/UIUserCache/clearCacheByKey/clientManagerGrid?static=true';

export const SET_CLIENT_CONNECTIONS_GRID_CACHE_URL = '/UIUserCache/setCacheValue/clientConnections?static=true';
export const GET_CLIENT_CONNECTIONS_GRID_CACHE_URL = '/UIUserCache/getCacheValue/clientConnections?static=true';
export const CLEAR_CLIENT_CONNECTIONS_GRID_CACHE_URL = '/UIUserCache/clearCacheByKey/clientConnections?static=true';

// Assignments
export const GET_ASSIGNMENTS_URL = '/assignments/getAssignments';
export const GET_ASSIGNMENTS_LOCATIONS_COUNT_URL = '/assignments/getAssignmentsLocationsCount';
export const GET_ASSIGNMENTS_NODE_OPTIONS_URL = '/ajaxcontroller/getAssignments';
export const SAVE_ASSIGNMENTS_URL = '/assignments/saveAssignments';
export const GET_ASSIGNMENTS_RETAILERS_URL = '/assignments/getRetailers';
export const GET_ASSIGNMENTS_LOCATIONS_BY_RETAILER_URL = '/assignments/getLocationsByRetailer';
export const IMPORT_ASSIGNMENTS_QUICK_SELECT_UPLOAD_CSV_URL = '/assignments/importQuickSelectCsv';
export const GET_ASSIGNMENTS_QUICK_SELECT_UPLOAD_TEMPLATE_URL = '/download/EditListImportTemplate';
export const EXPORT_ASSIGNMENTS_FOR_SCHEDULING_TEMPLATE_URL = '/assignments/exportAssignmentsForScheduling';

// Login Page
export const GET_LOGIN_PAGE_LOGO_URL = '/miscextcontroller/getClientLogo';
export const GET_IDENTITY_PROVIDERS_DATA = '/sso/getSSOProviderNames';
export const DO_STANDARD_LOGIN_URL = '/login/authenticate';
export const DO_SSO_LOGIN_URL = '/sso/initiateLogin';
export const RECOVER_PASSWORD_URL = '/login/recover';
export const GET_SSO_ERROR_URL = '/sso/getError';
export const GET_APPETIZE_PREF_URL = '/login/getAppetizePreference';

// Page Footer
export const GET_PAGEFOOTER_INFO_URL = '/miscextcontroller/getCurrentBranchInfo';

// Location Overrides
export const SAVE_LOCATION_OVERRIDES = '/locationOverrides/saveLocationOverrides';
export const DOWNLOAD_TEMPLATE_LOCATION_OVERRIDES = '/locationOverrides/downloadTemplate';
export const GET_LOCATION_OVERRIDES_DATA = '/locationOverrides/getLocationOverridesData';
export const GET_LOCATION_OVERRIDES_SNAPSHOT_DATA = '/locationOverrides/getLocationOverridesSnapshot';
export const REMOVE_LOCATION_OVERRIDES_DATA = '/locationOverrides/removeLocationOverrides';
export const SAVE_LOCATION_OVERRIDE_INLINE_EDIT = '/locationOverrides/saveLocationOverridesInlineEdit';
export const SAVE_ESTIMATED_TIME = '/locationOverrides/saveEstimatedTime';
export const ADD_JOB = '/locationOverrides/addJob';
export const DELETE_JOB = '/locationOverrides/deleteJob';
export const READD_JOB = '/locationOverrides/reAddJob';

export const SET_LOCATION_OVERRIDE_GRID_CACHE_URL = '/UIUserCache/setCacheValue/locationOverrideGrid?static=true';
export const GET_LOCATION_OVERRIDE_GRID_CACHE_URL = '/UIUserCache/getCacheValue/locationOverrideGrid?static=true';
export const CLEAR_LOCATION_OVERRIDE_GRID_CACHE_URL = '/UIUserCache/clearCacheByKey/locationOverrideGrid?static=true';

export const SET_OPS_INSIGHT_CACHE_URL = '/UIUserCache/setCacheValue/insight?static=true';
export const GET_OPS_INSIGHT_CACHE_URL = '/UIUserCache/getCacheValue/insight?static=true';

// Client Manager
export const GET_CLIENT_MANAGER_GRID_URL = '/clientmanagercontroller/getClients';
export const CLIENT_MANAGER_API_URL = 'api/clientmanager/';
export const GET_CLIENT_MANAGER_DROPDOWN_URL = '/clientmanagercontroller/getClientsForDropdown';
export const EDIT_CLIENT_URL = '/clientmanagercontroller/editClient';
export const CREATE_CLIENT_URL = '/clientmanagercontroller/createClient';
export const SAVE_CLIENT_URL = '/api/clientmanager';
export const GET_CLIENT_CONNECTIONS_GRID_URL = '/clientconnectioncontroller/getConnections';
export const GET_CLIENT_CONNECTIONS_DROPDOWN_URL = '/clientconnectioncontroller/getClientsForDropdown';

// Prefereces
export const SET_FEATURE_FLAG = 'preferencescontroller/setFeatureFlag';
export const UPLOAD_CONTRACT_URL = '/preferencescontroller/uploadContractFile';
export const GET_CONTRACT_URL = '/preferencescontroller/getContractFile';
export const DELETE_CONTRACT_URL = '/preferencescontroller/deleteContractFile';
export const GET_PREFERENCE_MVPREFERENCE = '/preferencescontroller/getMvPreference';
export const GET_AI_SCHEDULING_PREFERENCE = '/preferencescontroller/getAISchedulingPreference';
export const SAVE_AI_SCHEDULING_PREFERENCE = '/preferencescontroller/saveAISchedulingPreference';

// Report Builder
export const REPORT_BUILDER_URL = 'reportingcontroller';
export const REPORT_DEFINITION_API_URL = '/api/reportDefinition';

export const GET_REPORTS_URL = `${REPORT_BUILDER_URL}/getReports`;
export const GET_REPORT_DETAILS_URL = `${REPORT_BUILDER_URL}/getReportDetails`;
export const GET_REPORT_BY_ID_URL = `${REPORT_BUILDER_URL}/getReportById`;
export const GET_REPORT_ROW_COUNT_URL = `${REPORT_BUILDER_URL}/getReportRowCount`;
export const REPORT_REFRESH_DATA_URL = `${REPORT_BUILDER_URL}/refreshReportData`;
export const REPORT_CREATE_URL = `${REPORT_BUILDER_URL}/createReport`;
export const SHARE_BY_USER_URL = `${REPORT_BUILDER_URL}/saveShareByUser`;
export const REPORT_UPDATE_URL = `${REPORT_BUILDER_URL}/updateReport`;
export const REPORT_GET_REPS_URL = `${REPORT_BUILDER_URL}/getReps`;
export const REPORT_GET_ITEMS_URL = `${REPORT_BUILDER_URL}/getItems`;
export const REPORT_GET_PROJECTS_URL = `${REPORT_BUILDER_URL}/getProjects`;
export const REPORT_GET_TEMPLATES_URL = `${REPORT_BUILDER_URL}/getTemplates`;
export const GET_REPS_FOR_SHARE_URL = `${REPORT_BUILDER_URL}/getRepsForShare`;
export const SET_REPORT_LIST_CACHE_URL = '/UIUserCache/setCacheValue/reportList?static=true';
export const GET_REPORT_LIST_CACHE_URL = '/UIUserCache/getCacheValue/reportList?static=true';
export const CLEAR_REPORT_LIST_CACHE_URL = '/UIUserCache/clearCacheByKey/reportList?static=true';
export const SET_REPORT_VIEW_CACHE_URL = '/UIUserCache/setCacheValue';
export const GET_REPORT_VIEW_CACHE_URL = '/UIUserCache/getCacheValue';
export const CLEAR_REPORT_VIEW_CACHE_URL = '/UIUserCache/clearCacheByKey';

// Deploy Task
export const RUN_DEPLOY_TASK_VISIT_LINK = '/deploytasks?v=visitLinks&file=setup&skipPrintInfo=true';

// Activity Log
export const FETCH_ACTIVITY_LOG_DATA = '/activityLog/getActivityLogData';

// Tag Manager
export const FETCH_TAG_MANAGER_DATA = '/tagmanagercontroller/getTagManagerData';
export const CREATE_TAG = '/tagmanagercontroller/createTagData';
export const UPDATE_TAG_STATUS = '/tagmanagercontroller/updateTagStatus';
export const SET_TAG_MANAGER_CACHE_URL = '/UIUserCache/setCacheValue/tagManager?static=true';
export const GET_TAG_MANAGER_CACHE_URL = '/UIUserCache/getCacheValue/tagManager?static=true';
export const CLEAR_TAG_MANAGER_CACHE_URL = '/UIUserCache/clearCacheByKey/tagManager?static=true';
export const FETCH_TAG_DATA_LISTS = '/tagmanagercontroller/getTagDataList';
